import { hierarchyIds } from "rtr-constants";

export function productIsHomeGood(product) {
  const categoryId = product?.category?.id ?? null;

  return categoryId === hierarchyIds.homegood;
}
